import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import Entity from '@/common/models/entity'
import Guid from '@/app/utils/guid'

class NodesService {

  public async findOneAsync<T>(className: NodeClassName, id: string) {
    const res = await axios.get<T>(`${className}/${id}`)
    return Responses.obj(res)
  }

  public saveAsync<T extends Entity>(className: NodeClassName, model: T) {
    if (model.id === Guid.empty()) {
      return this.createAsync<T>(className, model)
    }
    return this.updateAsync<T>(className, model)
  }

  public async deleteOneAsync<T>(className: NodeClassName, id: string) {
    const model = await this.findOneAsync<T>(className, id)
    if (model == null) {
      return
    }
    const result = await axios.post(`${className}/delete`, model)
    return Responses.obj(result) || model
  }

  private async createAsync<T>(className: NodeClassName, model: T) {
    const res = await axios.post<T>(`${className}/create`, model)
    return Responses.obj(res) || model
  }

  private async updateAsync<T>(className: NodeClassName, model: T) {
    const res = await axios.put<T>(`${className}/update`, model)
    return Responses.obj(res) || model

  }

}

export default new NodesService()
